import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import './App.scss';

// Pages
import Home from './pages/Home';
import MultiplicationTables from './pages/MultiplicationTables';
import BasicOperations from './pages/BasicOperations';
import LengthUnits from './pages/LengthUnits';
import MathOperations from './pages/MathOperations';
import About from './pages/About';

const App: React.FC = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

const AppContent: React.FC = () => {
  const location = useLocation();
  const isGamePage = location.pathname !== '/';
  const isHomePage = location.pathname === '/';

  return (
    <div className="App">
      {!isGamePage && !isHomePage && (
        <header className="App-header">
          <h1>Math Explorer</h1>
          <nav>
            <ul className="nav-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/multiplication-tables">Multiplication Tables</Link></li>
              <li><Link to="/basic-operations">Basic Operations</Link></li>
              <li><Link to="/length-units">Length Units Game</Link></li>
              <li><Link to="/math-operations">Math Operations</Link></li>
              <li><Link to="/about">About</Link></li>
            </ul>
          </nav>
        </header>
      )}
      <main className="App-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/multiplication-tables" element={<MultiplicationTables />} />
          <Route path="/basic-operations" element={<BasicOperations />} />
          <Route path="/length-units" element={<LengthUnits />} />
          <Route path="/math-operations" element={<MathOperations />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </main>
      {!isGamePage && !isHomePage && <footer className="App-footer" />}
    </div>
  );
};

export default App;
